import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=f3b0e25c&scoped=true&comments=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
import style0 from "./main.css?vue&type=style&index=0&id=f3b0e25c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b0e25c",
  null
  
)

export default component.exports